<template>
  <div>
    <div class="padding">
        <van-checkbox-group v-model="clerkCategoryIds" :max="clerkCategoryCount" :disabled="isSave">
            <van-cell-group >
                <van-cell
                        v-for="(item, index) in categoryList"
                        clickable
                        :key="index"
                        :title="item.name"
                        @click="isSave?'':onCheckboxChange(index,item.id)"
                        disabled
                >
                    <template slot="right-icon">
                        <van-checkbox :name="item.id" ref="categoryCheckbox" />
                    </template>
                </van-cell>
            </van-cell-group>
        </van-checkbox-group>

        <div class="text-center margin-tb" v-if="!isSave || !clerkJoinCategoryApply">
            <van-button type="primary" size="large" @click="submit">保存</van-button>
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Cell, CellGroup, Checkbox, CheckboxGroup, Button, Toast, Dialog, Field, Icon } from 'vant';
  import { getCategoryList } from '@/api/category'
  import { getClerk, updateCategory } from '@/api/clerk/clerk'

  Vue.use(Cell)
        .use(CellGroup)
        .use(Checkbox)
        .use(CheckboxGroup)
        .use(Button)
        .use(Toast)
        .use(Dialog)
        .use(Field)
        .use(Icon)

  export default {
    name: 'updateCategory',
    data () {
      return {
        categoryList: [],
        clerkCategoryCount:null,
        clerkCategoryIds: [],
        clerkJoinCategoryApply: false
      }
    },
    mounted() {
      this.loadData()
    },
    computed:{
      isSave(){
        return !this.$ClerkPermission.modifiableClerkAttr.includes('category')
      }
    },
    methods: {
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        // 获取分类列表
        getCategoryList().then(res => {
          const data = res.data
          if (data.code == 0) {
            this.categoryList = data.list
            this.clerkCategoryCount=data.clerkCategoryCount

            // 获取店员分类
            getClerk().then(res => {
              Toast.clear()
              const data = res.data;
              if (data.code == 0) {
                this.clerkCategoryIds = data.clerkCategoryIds;
                this.clerkJoinCategoryApply = data.clerkJoinCategoryApply
              } else {
                Dialog.alert({
                  title: '加载' + this.$store.state.label.clerkLabel + '分类失败',
                  message: data.msg
                })
              }
            })

          } else {
            Dialog.alert({
              title: '加载分类失败',
              message: data.msg
            })
          }
        })
      },

      onCheckboxChange(index,id) {
        this.$refs.categoryCheckbox[index].toggle()
        if (this.clerkCategoryIds.length>=this.clerkCategoryCount){
          if (this.clerkCategoryIds.indexOf(id)==-1) {
            Toast('最多只能选择'+this.clerkCategoryCount+'个分类')
          }
        }
      },
      submit() {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        updateCategory(JSON.stringify(this.clerkCategoryIds)).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: '修改成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            })
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>


</style>
